import { z } from 'zod';

export const SignUpValidator = z
  .object({
    email: z
      .string()
      .email({
        message: 'Please enter a valid email address.',
      })
      .min(1, {
        message: 'Please enter email.',
      }),
    phone: z.string().min(1, {
      message: 'Please enter phone number.',
    }),
    password: z.string().min(1, {
      message: 'Please enter password.',
    }),
    confirmPassword: z.string().min(1, {
      message: 'Please enter confirm password.',
    }),
  })
  .refine((data) => data.password === data.confirmPassword, {
    path: ['confirmPassword'],
    message: 'Passwords does not match',
  });

export type SignUpFormData = z.infer<typeof SignUpValidator>;
